import styled from 'styled-components';

export const Container = styled.div`
  height: 90%;
`;

export const Content = styled.div`
  height: 100%;
  margin-top: 40px;
  form {
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .select {
      width: inherit;
      margin-bottom: 30px;
    }
  }
`;

export const LoadingText = styled.p`
  color: #999;
  font-size: 14px;
  margin-top: 16px;
`;
